 // Selectionne le noeud dont les mutations seront observées
 var targetNode = document.querySelector('#main-collection-product-grid');
 // Options de l'observateur (quelles sont les mutations à observer)
 var config = { childList: true };

 // Fonction callback à éxécuter quand une mutation est observée
 var callback = function(mutationsList) {

     for(var mutation of mutationsList) {

         if (mutation.type == 'childList') {
            
            // Find links that are used when clicking on the product image 
            let node_products = document.querySelectorAll("#main-collection-product-grid .grid__item") || [];

            node_products.forEach((node_product) => {

                const product = {
                    node: node_product,
                    title: node_product.innerText.toLowerCase()
                }
                
                if (product.title.includes('machine') || product.title.includes('moulin') || product.title.includes('grinder')) return

                node_product.classList.add("hide-equate-checkbox");
                  
            });

            // Arrêt de l'observeur (peut ne pas vouloir le disconnect selon les cas)
            observer.disconnect();
         }
     }
 };


 if (true) {
     // Créé une instance de l'observateur lié à la fonction de callback
     var observer = new MutationObserver(callback);
     // Commence à observer le noeud cible pour les mutations précédemment configurées
     observer.observe(targetNode, config);
 }
